module.exports = __webpack_public_path__ + "static/media/tree1980.d2ceb43b.jpg";